import {injectable} from "inversify";
import {Player, Team} from "@/modules/team/entity";
import {TransferLog} from "@/modules/transfer-market/entity";
import chance, {roundFront} from "@/modules/base/services/chance";
import {Season} from "@/modules/season/entity";

@injectable()
export default class TransferLogFactory {
  public async create(player: Player) {
    const teams = await Team
      .createQueryBuilder('team')
      .orderBy('RANDOM()')
      .take(2)
      .getMany();

    if (teams.length !== 2) {
      return;
    }

    const log = new TransferLog();
    log.player = player;
    log.transferredAt = chance.date();
    log.season = await Season
      .createQueryBuilder('season')
      .orderBy('RANDOM()')
      .getOneOrFail();
    log.from = teams[0];
    log.to = teams[1];
    log.price = roundFront(chance.integer({min: 1000, max: 15000000}));
    await log.save();

    return log;
  }
}
